module.exports = __webpack_public_path__ + "static/img/42.6188c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pousada/42.jpg
// module id = SO8R
// module chunks = 1